import { usePrivatePageStore } from '@/v2/domains/Auth/stores/usePrivatePageStore';
import { useFlowAnalyticsEventsQueueStore } from '@/v2/domains/Analytics/stores/flowAnalyticsEventsQueue.store';

export default function useIsFlowPage(): boolean {
  const isFlowPage = usePrivatePageStore((s) => s.isFlowPage);
  const flow = useFlowAnalyticsEventsQueueStore((s) => s.flow);

  return isFlowPage || !!flow;
}
